import { AbstractControl } from '@angular/forms';
import { AfterViewInit, ElementRef, OnChanges, OnInit } from '@angular/core';
import { TranslateService } from '../translate';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
var FormErrorIndicatorDirective = /** @class */ (function () {
    function FormErrorIndicatorDirective(el, translate) {
        var _this = this;
        this.el = el;
        this.translate = translate;
        this.position = 'button';
        this.highlightClass = '';
        this.errorRootNode = null;
        this.asyncValidatorLoaderNode = null;
        this.errorMap = {};
        // Служит для ограничения срабатываний кол-ва валидаций, ибо при валидации идёт работа с DOM
        // Да, руками делаем DOM - пока не знаю лучшего решения
        this.validateEvent = new Subject();
        this.validateEvent.pipe(debounceTime(100)).subscribe(function () { return _this.update(); });
    }
    FormErrorIndicatorDirective.prototype.update = function () {
        var me = this, el = this.el.nativeElement;
        if (!me.formErrorIndicator) {
            return true;
        }
        if (me.formErrorIndicator.status === 'DISABLED') {
            me.removeRootEl();
            return true;
        }
        if (me.formErrorIndicator.status === 'VALID') {
            me.removeRootEl();
            if (me.asyncValidatorLoaderNode) {
                me.asyncValidatorLoaderNode.remove();
                me.asyncValidatorLoaderNode = null;
            }
            return true;
        }
        if (me.formErrorIndicator.status === 'PENDING') {
            if (!me.asyncValidatorLoaderNode) {
                me.asyncValidatorLoaderNode = document.createElement('div');
                me.asyncValidatorLoaderNode.innerHTML = "<div>Checking...</div>";
                el.parentNode.insertBefore(me.asyncValidatorLoaderNode, el.nextSibling);
            }
            return;
        }
        if (me.asyncValidatorLoaderNode) {
            me.asyncValidatorLoaderNode.remove();
            me.asyncValidatorLoaderNode = null;
        }
        // Поскольку мы не знаем списка всех валидаторов для элемента формы,
        // тогда проще все удалить и построить заново
        me.clearErrorList();
        if (!me.formErrorIndicator.errors) {
            return;
        }
        var errorNameList = Object.keys(me.formErrorIndicator.errors);
        if (errorNameList.length > 0) {
            if (!me.errorRootNode) {
                me.errorRootNode = document.createElement('div');
                me.errorRootNode.className = 'alert alert-danger';
                var parentNode_1 = el.parentNode;
                if (me.position === 'top') {
                    el.parentNode.insertBefore(me.errorRootNode, el);
                }
                else if (me.position === 'button') {
                    el.parentNode.insertBefore(me.errorRootNode, el.nextSibling);
                }
                else {
                    throw new Error("Input position has not valid value \"" + me.position + "\"");
                }
                if (me.highlightClass) {
                    var classList = me.highlightClass.split(' ');
                    classList.forEach(function (str) {
                        if (!parentNode_1.classList.contains(str)) {
                            parentNode_1.classList.add(str);
                        }
                    });
                }
            }
            errorNameList.forEach(function (key) {
                var _a;
                var error = me.formErrorIndicator.errors[key];
                var errorText = key;
                if (error.message) {
                    errorText = error.message;
                }
                else if (error.i18n) {
                    errorText = (_a = me.translate).__A.apply(_a, [error.i18n].concat(error.params));
                }
                var node = document.createElement('div');
                node.innerHTML = "<div>" + errorText + "</div>";
                me.errorRootNode.appendChild(node);
                me.errorMap[key] = node;
            });
        }
    };
    FormErrorIndicatorDirective.prototype.clearErrorList = function () {
        var me = this;
        // удаляем ноды сообщений об ошибках
        Object.keys(me.errorMap).forEach(function (key) {
            me.errorMap[key].remove();
            delete me.errorMap[key];
        });
    };
    FormErrorIndicatorDirective.prototype.removeRootEl = function () {
        var me = this;
        if (me.errorRootNode) {
            me.clearErrorList();
            var parentNode_2 = me.el.nativeElement.parentNode;
            if (me.highlightClass) {
                var classList = me.highlightClass.split(' ');
                classList.forEach(function (str) {
                    if (parentNode_2.classList.contains(str)) {
                        parentNode_2.classList.remove(str);
                    }
                });
            }
            me.errorRootNode.remove();
            me.errorRootNode = null;
        }
    };
    FormErrorIndicatorDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.formErrorIndicator) {
            return true;
        }
        this.formErrorIndicator.statusChanges.subscribe(function () { return _this.validateEvent.next(); });
        this.formErrorIndicator.valueChanges.subscribe(function () { return _this.validateEvent.next(); });
    };
    FormErrorIndicatorDirective.prototype.ngOnChanges = function () {
        this.validateEvent.next();
    };
    FormErrorIndicatorDirective.prototype.ngAfterViewInit = function () {
        this.validateEvent.next();
    };
    return FormErrorIndicatorDirective;
}());
export { FormErrorIndicatorDirective };
